export const language = {
  defaultTitle: 'انتخاب فایل',
  uploadedFile: 'فایل بارگذاری‌شده',
  previewAlt: 'preview',
  uploadError: 'خطا در بارگذاری',
  retry: 'تلاش مجدد',
  remove: 'حذف',

  maxFileSizeError: (maxSize: number) => `حجم فایل نباید بیشتر از ${maxSize} مگابایت باشد`,
  invalidFormatError: 'فرمت فایل انتخاب‌شده مجاز نیست',
  dimensionError: (width: number, height: number) =>
    `ابعاد تصویر باید ${width}×${height} پیکسل باشد`,
  readDimensionsError: 'خطا در خواندن ابعاد تصویر',
  uploadFailedError: 'خطا در بارگذاری فایل',
};
